import { Image } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGetLineUrl } from "../../../hooks/LineLink/customerService.hooks";
import { Pay1, Pay2 } from "./images/layout1";
import Facebook from "./images/layout1/Facebook";
import Instagram from "./images/layout1/Instagram";
import Linkedin from "./images/layout1/Linkedin";
import Twitter from "./images/layout1/Twitter";
import styles from "./style.2esim.module.scss";

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: customerService } = useGetLineUrl({});

  const getSocialMediaUrl = (name: any) => {
    const url = customerService?.filter((u: any) => u.name === name);
    if (url) {
      window.open(url[0]?.value);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.footer}>
        <div className={styles.footerItems}>
          <div className={styles.footerItemsTop}>
            <div>
              <img
                src={`/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/footer_logo.png`}
                className={styles.footerLogo}
                // preview={false}
                alt="logo"
              />
            </div>
            <div className={styles.paymentGroup}>
              <Image
                src={Pay1}
                className={styles.pIcon}
                alt="paymentMethods-JCB"
                preview={false}
              />
              <Image
                src={Pay2}
                className={styles.pIcon}
                alt="paymentMethods-VISA"
                preview={false}
              />
              {/* <Image
                src={Pay3}
                className={styles.pIcon}
                alt="paymentMethods-AMEX"
                preview={false}
              />
              <Image
                src={Pay4}
                className={styles.pIcon}
                alt="paymentMethods-Union-Pay"
                preview={false}
              />
              <Image
                src={Pay5}
                className={styles.pIcon}
                alt="paymentMethods-Apple-Pay"
                preview={false}
              /> */}
            </div>
            <div className={styles.socialGroup}>
              <div className={styles.socialIcon}>
                <Facebook
                  color="var(--primary600)"
                  onClick={() => {
                    getSocialMediaUrl("faceboock_link");
                  }}
                />
              </div>
              <div className={styles.socialIcon}>
                <Twitter
                  color="var(--primary600)"
                  onClick={() => {
                    getSocialMediaUrl("twitter_link");
                  }}
                />
              </div>
              <div className={styles.socialIcon}>
                <Linkedin
                  color="var(--primary600)"
                  onClick={() => {
                    getSocialMediaUrl("linkedin_link");
                  }}
                />
              </div>
              <div className={styles.socialIcon}>
                <Instagram
                  color="var(--primary600)"
                  onClick={() => {
                    getSocialMediaUrl("instagram_link");
                  }}
                />
              </div>
            </div>
            <div className={styles.companyInfo}>
              {`${t("company.info.name")} | ${t(
                "normal.uniformNumber"
              )} : 94197195 ｜ v${process.env.REACT_APP_VERSION}`}
            </div>
            <div className={styles.copyright}>
              {t("footer.copyright", {
                brand: process.env.REACT_APP_PROD_NAME_DEV,
              })}
            </div>
          </div>
          <div className={styles.footerItemsBottom}>
            {/* waiting for api */}
            {/* <div className={styles.wrapper}>
              <div className={styles.label}>{t("footer.popularCountries")}</div>
              <div className={styles.countryGroup}>
                {coutries.map((i) => {
                  return <div key={i.id}>{i.country}</div>;
                })}
              </div>
            </div> */}
            <div className={styles.wrapper}>
              <div className={styles.label}>{t("footer.relatedTerms")}</div>
              <div className={styles.termsGroup}>
                <span
                  className={styles.termsLink}
                  onClick={() => navigate("/terms")}
                >
                  {t("normal.termsOfService")}
                </span>
                <span
                  className={styles.termsLink}
                  onClick={() => navigate("/privacypolicy")}
                >
                  {t("normal.privacyPolicy")}
                </span>
                {/* hide returnExchange because of request by PM */}
                <span
                  className={styles.termsLink}
                  onClick={() => navigate("/returnandexchange")}
                >
                  {t("normal.returnExchange")}
                </span>
              </div>
            </div>
            <div className={styles.wrapper}>
              <div className={styles.label}>{t("footer.csInfo")}</div>
              <div className={styles.csGroup}>
                {/* PM說隱藏email */}
                {/* <div>
                  {t("footer.csEmail", {
                    email: process.env.REACT_APP_CS_MAIL_ADDRESS,
                  })}
                </div> */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: t("footer.csServiceHour"),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
